import { createAsyncThunk } from '@reduxjs/toolkit'
import apiRequest from "../../lib/http"
import { normalizeError } from "../../utils/errorHelpers"

export const fetchBrandGrants = createAsyncThunk('company/fetchBrandGrants', async (userId, { rejectWithValue }) => {
  try {
    const response = await apiRequest.get(`/company/access/${userId}`)
    return response.data
  } catch (error) {
    return rejectWithValue(normalizeError(error))
  }
})

export const grantBrand = createAsyncThunk('company/grantBrand', async ({ userId, companyId }, { rejectWithValue }) => {
  try {
    const response = await apiRequest.post(`/company/access/${userId}`, { companyId })
    return response.data
  } catch (error) {
    return rejectWithValue(normalizeError(error))
  }
})

export const revokeBrand = createAsyncThunk('company/revokeBrand', async ({ userId, companyId }, { rejectWithValue }) => {
  try {
    const response = await apiRequest.delete(`/company/access/${userId}/${companyId}`)
    return response.data
  } catch (error) {
    return rejectWithValue(normalizeError(error))
  }
})
